import React, { useEffect, useState } from "react";
import { db } from "../../firebaseConfig";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import ro from "/src/content/ro.json";
import { toDisplayDate } from "../../utils/date";

const TabelProgram = () => {
  const [programe, setPrograme] = useState([]);
  const cellBase =
    "px-3 py-3 text-center align-middle whitespace-normal break-words leading-tight text-sm md:text-base";
  const headerCell = `${cellBase} font-semibold tracking-wide`;
  const locatieCell = `${cellBase} max-w-[140px]`;
  const locatieHeader = `${headerCell} max-w-[140px]`;
  const mobileRowBase = "min-h-[48px] w-full flex items-center";
  const mobileLabelCell = `simulare-mobile-label ${mobileRowBase} px-3 py-2 text-left text-xs font-semibold tracking-wide`;
  const mobileValueCell = `${mobileRowBase} px-2 text-center text-sm justify-center`;

  const formatDate = (value) => toDisplayDate(value);

  useEffect(() => {
    const q = query(
      collection(db, "stabilire_program"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPrograme(data);
      },
      (error) => {
        console.error("Eroare la ascultarea programelor:", error);
      }
    );

    return () => unsubscribe();
  }, []);

  const isScrollable = programe.length > 2;

  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Desktop table */}
      <div className="simulare-tabel hidden md:block">
        <table className="w-full table-fixed">
          <thead>
            <tr className="simulare-header">
              <th className={headerCell}>{ro.simulare.table.headers.traseu}</th>
              <th className={headerCell}>{ro.simulare.table.headers.data}</th>
              <th className={headerCell}>{ro.simulare.table.headers.ora}</th>
              <th className={locatieHeader}>
                {ro.simulare.table.headers.locatie}
              </th>
              <th className={headerCell}>{ro.simulare.table.headers.pret}</th>
            </tr>
          </thead>
          <tbody>
            {programe.length > 0 ? (
              programe.map((program) => (
                <tr className="simulare-row" key={program.id}>
                  <td className={cellBase}>{program.tipProgram || "-"}</td>
                  <td className={cellBase}>
                    {formatDate(program.data) || "-"}
                  </td>
                  <td className={cellBase}>{program.ora || "-"}</td>
                  <td className={locatieCell}>{program.locatie || "-"}</td>
                  <td className={cellBase}>{program.cost || "-"}</td>
                </tr>
              ))
            ) : (
              <tr className="simulare-row">
                <td className={`${cellBase} opacity-70`} colSpan={5}>
                  {ro.simulare.table.empty}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile table (headers as first column) */}
      <div className="md:hidden">
        {programe.length > 0 ? (
          <div className="simulare-mobile">
            <div
              className={`${
                isScrollable ? "overflow-x-auto simulare-scroll" : ""
              } scroll-smooth`}
            >
              <div className="flex w-max min-w-full items-stretch divide-x divide-black/10 px-3 py-4">
                <div className="sticky left-0 z-20 flex w-[120px] min-w-[120px] flex-col overflow-hidden rounded-xl border border-white/80 divide-y divide-black/10">
                  <div className={mobileLabelCell}>
                    {ro.simulare.table.headers.traseu}
                  </div>
                  <div className={mobileLabelCell}>
                    {ro.simulare.table.headers.data}
                  </div>
                  <div className={mobileLabelCell}>
                    {ro.simulare.table.headers.ora}
                  </div>
                  <div className={mobileLabelCell}>
                    {ro.simulare.table.headers.locatie}
                  </div>
                  <div className={mobileLabelCell}>
                    {ro.simulare.table.headers.pret}
                  </div>
                </div>

                {programe.map((program) => (
                  <div
                    className="simulare-card flex w-[160px] min-w-[160px] shrink-0 flex-col items-center justify-between divide-y divide-black/10 border border-white/80 p-0"
                    key={program.id}
                  >
                    <div className={mobileValueCell}>
                      {program.tipProgram || "-"}
                    </div>
                    <div className={mobileValueCell}>
                      {formatDate(program.data) || "-"}
                    </div>
                    <div className={mobileValueCell}>
                      {program.ora || "-"}
                    </div>
                    <div className={mobileValueCell}>
                      {program.locatie || "-"}
                    </div>
                    <div className={mobileValueCell}>
                      {program.cost || "-"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="simulare-tabel">
            <div className="simulare-row">
              <span className={`${cellBase} opacity-70`}>
                {ro.simulare.table.empty}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabelProgram;
